import { DropdownTab } from "designSystem/components/select/SingleSelectWithTabs";
import { Box, DataGridCardProps, Grid, SingleSelectWithTabs, Text } from "designSystem/index";
import { ComponentItem } from "designSystem/types/component-item-types";
import { ComponentItemDataStore } from "designSystem/utilities/component-item-functions";
import React from "react";

const data1: ComponentItem[] = [];
const data2: ComponentItem[] = [];

for (let i = 0; i < 100; ++i) {
	data1.push({
		id: i.toString(),
		name: `Item ${i}`,
	});

	data2.push({
		id: (i * 2).toString(),
		name: `Item ${i * 2}`,
	});
}

const store1 = new ComponentItemDataStore<ComponentItem>(data1);
const store2 = new ComponentItemDataStore<ComponentItem>(data2);

const Card = (props: DataGridCardProps<ComponentItem>) => {
	const { item: { id, name } } = props;
	return (
		<Box>
			<Text text={name} />
		</Box>
	);
};

export default () => {
	const onSelectItem = (item: ComponentItem) => {
		alert(item.name);
	};

	const tabs: DropdownTab<ComponentItem>[] = [
		{
			nameRes: "Test",
			dataGridProps: {
				CardComponent: Card,
				store: store1,
			},
			listItemProps: {
				height: 56,
			},
		},
		{
			nameRes: "Second Tab",
			dataGridProps: {
				CardComponent: Card,
				store: store2,
			},
			listItemProps: {
				height: 56,
			},
		},
	];

	return (
		<Grid
			container
			direction="column"
			spacing={4}
		>
			<Grid item>
				<SingleSelectWithTabs<ComponentItem>
					onSelect={onSelectItem}
					placeholderRes="Select Value"
					tabs={tabs}
				/>
			</Grid>
		</Grid>
	);
};